class Employee {
    public no: string = "";
    public name: string = "";
    public id?: string = "";
    public dimDepartmentId: string = "";
    public phone: string = "";
    public licenseNo: string = "";
    public licenseType: string = "1";
    public employType: string = "";
}

export default Employee;